module.exports = __webpack_public_path__ + "static/media/heat_2.ed43abfc.png";